module.exports = __webpack_public_path__ + "fonts/NunitoSans-Regular.a427ddb.ttf";